/**
 * Created by why on 2019/10/21.
 */
import axios from '@/libs/api.request'
export const getByCondition = (data) => {
  return axios.request({
    url: '/i18n/getByCondition',
    params: data,
    method: 'get'
  })
}

export const getAll = () => {
  return axios.request({
    url: '/i18n/getAll',
    method: 'get'
  })
}

export const save = (data) => {
  return axios.request({
    url: '/i18n/save',
    data: data,
    method: 'post'
  })
}

export const edit = (data) => {
  return axios.request({
    url: '/i18n/edit',
    data: data,
    method: 'post'
  })
}

export const delByIds = (ids) => {
  return axios.request({
    url: `/i18n/delByIds/${ids}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/i18n-manage.js